import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="m15.294 12.941 4.417 30.925L84.118 50h-63.53l-2.647 15.882-2.647 15.883L100 50ZM20.588 50 10 65.882h5.964z" />
  </svg>
);
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
